/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AppDatePicker from '../../../../components/DatePicker';
import TextInput from '../../../../components/input';
import SelectSearch from '../../../../components/SelectSearch';
import useForm from '../../../../customHooks/useForm';
import './PersonalInfoEdit.scss';
import StyledButton from '../../../../components/StyledButton';
import { UPDATE_USER_PROFILE } from '../../../../graphql/admin_mutations';
import useToast from '../../../../customHooks/useToast';

interface IPersonalInfoEdit{
  payload:any;
  disableMode?: boolean;
  buttonState?: boolean;
  fetchCustomer?: any;
  customerId?:any;
}
export const PersonalInfoEdit = ({
  payload, disableMode, fetchCustomer, customerId,
}:IPersonalInfoEdit) => {
  const [countries, setCountries]: any = useState([]);
  const isAllowUpdate = payload?.hasProfileUpdateRequest;
  const history = useHistory();
  const Toast = useToast();

  const genderOptions = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Others', value: 'Others' },
  ];

  const getCountryList = async () => {
    const baseUrl = 'https://restcountries.com/v3.1/all';
    try {
      const result = await fetch(baseUrl);
      const data = await result?.json();
      const getData = data?.map((item: any) => ({ label: item?.name?.common, value: item?.name?.common }));
      return setCountries(getData);
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const {
    formValues,
    handleChange,
    resetForm,
  } = useForm({
    enrollment_type: '',
    enrollment_type_other: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    gender: '',
    dob: '',
    nationality: '',
    studentId: '',
    permanentResidency: '',
  });

  const handleDateChange = (date) => {
    handleChange({
      target: {
        name: 'dob',
        value: new Date(date),
      },
    });
  };

  const [updateUserProfile, { loading: updateUserProfileLoading }] = useMutation<
  { adminUpdateUserProfileCa: any },
  any
>(UPDATE_USER_PROFILE);

  useEffect(() => {
    if (payload?.email) {
      resetForm({
        firstName: payload?.firstName || '********',
        lastName: payload?.lastName || '********',
        email: payload?.email || '********',
        phone: payload?.phone || '********',
        gender: payload?.gender || '********',
        dob: payload?.dob ? new Date(payload?.dob) : '',
        nationality: payload?.userRtDetail?.nationality || '********',
        studentId: `ID: ${payload?.studentId || '********'}`,
        permanentResidency: payload?.userRtDetail?.enrollment_type || payload?.userRtDetail?.enrollment_type_other || '********',
      });
    }
  }, [payload]);

  const fullName = `${payload?.firstName} ${payload?.lastName}`;

  const handleSubmit = async () => {
    const input = {
      dob: moment(formValues?.dob).format('DD-MMM-YYYY'),
      nationality: formValues?.nationality,
      gender: formValues?.gender,
    };

    const variables = {
      input,
      userId: customerId,
    };

    if (!updateUserProfileLoading) {
      try {
        const res = await updateUserProfile({
          variables,
        });

        if (res?.data?.adminUpdateUserProfileCa?.status === 200) {
          fetchCustomer();

          Toast.success(res?.data?.adminUpdateUserProfileCa?.message || 'Operation successful');
        } else {
          Toast.error(res?.data?.adminUpdateUserProfileCa?.message || 'Operation Failed');
        }
      } catch (e: any) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (

    <div className="edit-wrapper">
      <div className="edit-details">
        <div className="edit-wrapper-text">
          About
          {' '}
          {fullName}
        </div>
        <div className="row">
          <div className="col-md-6 col-12">
            <TextInput
              name="firstName"
              value={formValues?.firstName}
              label="First name"
              disabled
              width="100%"
              customOnChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-12">
            <TextInput
              name="lastName"
              value={formValues?.lastName}
              label="Last name"
              disabled
              width="100%"
              customOnChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-12">
            <TextInput
              name="studentId"
              value={formValues?.studentId}
              label="Student ID"
              disabled
              width="100%"
              customOnChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-12">
            <TextInput
              name="email"
              value={formValues?.email}
              label="Email address"
              disabled
              width="100%"
              customOnChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-12">
            <TextInput
              name="phone"
              value={formValues?.phone}
              label="Phone number"
              disabled
              width="100%"
              customOnChange={handleChange}
            />
          </div>
          <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
            <SelectSearch
              name="gender"
              options={genderOptions}
              value={formValues?.gender}
              placeholder="Gender"
              width="100%"
              onChange={handleChange}
              disabled={disableMode}
            />
          </div>
          <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
            <AppDatePicker
              value={formValues?.dob}
              placeholder="Birthdate"
              onChange={handleDateChange}
              maxDate={moment().subtract(18, 'years').format()}
              disabled={disableMode}
              dateFormat="dd-MMM-yyyy"
            />
          </div>
          {/* <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
            <SelectSearch
              options={[
                { label: 'Yes', value: 'yes' },
                { label: 'No', value: 'no' },
              ]}
              placeholder="Permanent residency"
              width="100%"
              name="permanentResidency"
              value={formValues?.permanentResidency}
              onChange={handleChange}
              disabled={disableMode}
            />
          </div> */}
          <div className="col-md-6 col-12" style={{ marginBottom: '24px' }}>
            <SelectSearch
              options={countries}
              name="nationality"
              placeholder="Nationality"
              onChange={handleChange}
              value={formValues?.nationality}
              disabled={disableMode}
            />
          </div>
        </div>
        <div className="flexed-end">
          <div className="customer-update-btn-wrapper">
            <StyledButton
              name="CANCEL"
              backgroundColor="white"
              color="#000"
              padding="10px 24px"
              borderRadius="4px"
              border="1px solid #000"
              onClick={() => history?.goBack()}
              disabled={updateUserProfileLoading}
              marginRight="16px"
              height="32px"
              width="140px"
              fontSize="12px"
              fontWeight="700"
            />
          </div>
          <div className="customer-update-btn-wrapper">
            <StyledButton
              name={updateUserProfileLoading ? 'Please wait...' : 'SAVE CHANGES'}
              backgroundColor={isAllowUpdate ? 'black' : '#f5f5f5'}
              color={isAllowUpdate ? 'white' : '#C4C4C4'}
              padding="10px 24px"
              borderRadius="4px"
              border="none"
              height="32px"
              fontSize="12px"
              fontWeight="700"
              onClick={handleSubmit}
              disabled={!isAllowUpdate}
            />
          </div>
        </div>
      </div>
    </div>

  );
};
